module.exports = __webpack_public_path__ + "img/propertysupervise3.31d6dad1.png";